import * as React from "react";
import { RMarker } from "maplibre-react-components";
import { SiteType } from "@/types";
import { useTailwind } from "@oreme/ui";

interface SiteMapMarkerProps {
  site: SiteType;
}

function SiteMapMarker({ site }: Readonly<SiteMapMarkerProps>) {
  const tailwind = useTailwind();
  const latitude = Number(site.latitude);
  const longitude = Number(site.longitude);
  const color = tailwind.theme.colors.orange[500];

  return (
    <RMarker
      initialColor={color}
      key={`site-marker-${site.site_id}`}
      latitude={latitude}
      longitude={longitude}
    />
  );
}

export { SiteMapMarker };
